import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const DiscountShowcase = () => {
  const discountTiers = [
    {
      id: 1,
      title: "GANG PREMIUM",
      discount: "30%",
      originalPrice: "499 TND",
      newPrice: "149TND",
      items: ["Hoodies exclusifs", "Sneakers limitées", "Accessoires premium"],
      icon: "Crown",
      gradient: "from-accent to-error"
    },
    {
      id: 2,
      title: "STREET ELITE",
      discount: "35%",
      originalPrice: "250 TND",
      newPrice: "87 TND",
      items: ["T-shirts design", "Casquettes custom", "Sacs streetwear"],
      icon: "Star",
      gradient: "from-error to-warning"
    },
    {
      id: 3,
      title: "URBAN BASIC",
      discount: "50%",
      originalPrice: "99 TND",
      newPrice: "49 TND",
      items: ["Basiques urbains", "Stickers gang", "Pins collection"],
      icon: "Zap",
      gradient: "from-warning to-success"
    }
  ];

  return (
    <div className="space-y-8 py-12">
      <motion.div
        className="text-center px-4"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="text-3xl sm:text-4xl font-heading font-bold text-foreground mb-4">
          RÉDUCTIONS EXPLOSIVES
        </h2>
        <p className="text-text-secondary font-body text-base sm:text-lg max-w-2xl mx-auto">
          Des prix jamais vus sur notre collection streetwear. 
          Profitez de ces offres limitées avant qu'il ne soit trop tard !
        </p>
      </motion.div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 px-4">
        {discountTiers?.map((tier, index) => (
          <motion.div
            key={tier?.id}
            className="relative group"
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: index * 0.2, duration: 0.8 }}
            whileHover={{ scale: 1.05 }}
          >
            {/* Glowing Background */}
            <div className={`absolute inset-0 bg-gradient-to-br ${tier?.gradient} opacity-20 rounded-2xl blur-xl group-hover:opacity-30 transition-opacity duration-300`}></div>
            
            <div className="relative bg-surface/90 backdrop-blur-lg border border-border rounded-2xl p-4 sm:p-6 h-full flex flex-col">
              {/* Header */}
              <div className="flex items-center justify-between mb-4 sm:mb-6">
                <div className={`w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br ${tier?.gradient} rounded-xl flex items-center justify-center`}>
                  <Icon name={tier?.icon} className="text-white w-5 h-5 sm:w-6 sm:h-6" />
                </div>
                <motion.div
                  className={`text-2xl sm:text-3xl font-heading font-bold bg-gradient-to-r ${tier?.gradient} bg-clip-text text-transparent`}
                  animate={{ scale: [1, 1.1, 1] }}
                  transition={{ duration: 2, repeat: Infinity, delay: index * 0.5 }}
                >
                  -{tier?.discount}
                </motion.div>
              </div>

              {/* Title */}
              <h3 className="text-lg sm:text-xl font-heading font-bold text-foreground mb-4">
                {tier?.title}
              </h3>

              {/* Price */}
              {tier.newPrice && (
                <div className="mb-4 sm:mb-6">
                  <div className="flex items-baseline space-x-2">
                    <span className="text-xl sm:text-2xl font-heading font-bold text-accent">
                      {tier?.newPrice}
                    </span>
                    {tier.originalPrice &&
                      <span className="text-base sm:text-lg text-text-secondary line-through">
                        {tier?.originalPrice}
                      </span>
                    }
                  </div>
                  {tier.originalPrice && (parseInt(tier?.originalPrice) - parseInt(tier?.newPrice)) > 0 &&
                    <div className="text-xs sm:text-sm font-caption text-success mt-1">
                      Économisez {parseInt(tier?.originalPrice) - parseInt(tier?.newPrice)}TND
                    </div>
                  }
                </div>
              )}

              {/* Items List */}
              <div className="space-y-2 sm:space-y-3 flex-grow">
                {tier?.items?.map((item, itemIndex) => (
                  <motion.div
                    key={itemIndex}
                    className="flex items-center space-x-3"
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: (index * 0.2) + (itemIndex * 0.1) }}
                  >
                    <div className="w-2 h-2 bg-accent rounded-full flex-shrink-0"></div>
                    <span className="text-text-secondary font-body text-xs sm:text-sm">
                      {item}
                    </span>
                  </motion.div>
                ))}
              </div>

              {/* Action Button */}
              <motion.button
                className={`w-full mt-4 sm:mt-6 bg-gradient-to-r ${tier?.gradient} text-white font-heading font-bold py-2 px-4 sm:py-3 sm:px-6 rounded-xl hover:shadow-lg transition-all duration-300 text-sm sm:text-base`}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                PROFITER MAINTENANT
              </motion.button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default DiscountShowcase;